import { CopilotScript } from '@coach-bot/data-access/shared/models';
import { SentryEventType, sendErrorToSentry } from '@shared/sentry';

const COPILOT_SCRIPT_PREFIX = 'cb';

function wrap(code: string, formattedName: string) {
  return `try {
    ${code}
  } catch (e) {
    console.error('Error while running copilot script', e);
    try {
      window.postMessage({ type: '${SentryEventType.Error}', content: { error: e } }, window.location.origin);
    } catch (e) {
      console.error('Error while logging an error in Sentry.', e);
    }
  }
  //# sourceURL=copilot-script-${formattedName}.js`;
}

function getCopilotScripts(): CopilotScript[] {
  return JSON.parse(window.localStorage.getItem('copilotScripts') ?? '[]') as CopilotScript[];
}

try {
  console.info(`Loading copilot scripts...`);
  const copilotScripts = getCopilotScripts();
  console.info(`Found ${copilotScripts.length} copilot script(s):`);
  for (const script of copilotScripts) {
    const formattedName = script.name.toLowerCase().replace(/\s+/g, '-');
    const scriptId = `${COPILOT_SCRIPT_PREFIX}-${formattedName}`;

    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      console.info(`Copilot script '${script.name}' already loaded, skipping.`);
      continue;
    }

    const scriptElement = document.createElement('script');
    scriptElement.id = scriptId;
    scriptElement.innerHTML = wrap(script.code, formattedName);
    scriptElement.onload = function () {
      // @ts-ignore
      this.remove();
    };
    (document.head || document.documentElement).appendChild(scriptElement);
    console.info(`Copilot script '${script.name}' has been loaded.`);
  }
} catch (e) {
  console.error('Error while running copilot scripts', e);
  sendErrorToSentry({ error: e });
}
